import * as React from 'react';
import type { SvgProps } from 'react-native-svg';
import { SvgXml } from 'react-native-svg';

const xml = `
  <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path id="&#244;&#128;&#134;&#137;" d="M5.875 5.00282C5.875 5.1007 5.85806 5.19104 5.82418 5.27386C5.78654 5.35667 5.73007 5.43572 5.65479 5.51101L1.25614 9.81366C1.12815 9.93789 0.973814 10 0.793126 10C0.668902 10 0.557854 9.96989 0.459981 9.90966C0.358344 9.85319 0.27741 9.77602 0.21718 9.67815C0.156951 9.58027 0.126836 9.46923 0.126836 9.345C0.126836 9.16808 0.196476 9.00998 0.335757 8.87069L4.29962 5.00282L0.335757 1.13495C0.196476 0.995671 0.126836 0.835686 0.126836 0.654997C0.126836 0.534538 0.156951 0.425372 0.21718 0.327499C0.27741 0.225862 0.358344 0.14681 0.459981 0.0903444C0.557854 0.0301151 0.668902 0 0.793126 0C0.973814 0 1.12815 0.0639935 1.25614 0.191982L5.65479 4.49464C5.73007 4.56992 5.78654 4.64897 5.82418 4.73179C5.85806 4.81461 5.875 4.90495 5.875 5.00282Z" />
</svg>
`;

export const ChevronRight = (props: SvgProps) => (
  <SvgXml xml={xml} width="100%" height="100%" {...props} />
);
